<body class="exception-body notfound">
    <div class="exception-panel">
      <div class="exception-panel-content">
        <img src="../../assets/layout/images/exception/404-icon.png" style="margin-top:15px;">
        <h4>Service is unavailable at this time.</h4>
        <h5>Please try again later. If this problem continues, please contact Support.</h5>
      </div>

      <div class="exception-panel-footer">
        <a href="/login"> <i class="fa fa-home fa-2x fa-pull-rightright fa-border" style="margin-right:15px;"></i>Return to the login page.
        </a>
      </div>
    </div>
  </body>
